// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.estilo-titulo-select {
    font-size: .85rem;
    font-weight: bold;
    color: var(--cinza-em-aberto);
}

#select-button {
    margin-top: 0.15rem;
    display: flex;
    padding: 0.75rem;   
    align-items: center;
    justify-content: space-between;

    border-radius: .375rem;
    border: 1ox solid var(--fundo-input2);
    background-color: var(--fundo-input2);
}

.texto-azul {
    color: var(--azul-dixi);
}

#selected-value {
    color: var(--branco-padrao);
    font-size: 1rem;
}

#chevrons {
    color: var(--branco-padrao);
}

.pra-cima-select {
    display: none;
}

#options-view-button:focus + #select-button,
#options-view-button:checked + #select-button {
    outline: 1px solid var(--azul-dixi);
}

#custom-select-container {
    position: relative;
}

#options-view-button {
    all: unset;

    position: absolute;
    inset: 0;

    cursor: pointer;
    z-index: 3;
}

#options {
    background-color: var(--fundo-input2);

    border-radius: 0 0 8px 8px;

    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);
    outline: 1px solid var(--fundo-input2);

    padding: .4rem 0.1rem;
}

.option {
    display: flex;
    align-items: center;
    gap: .5rem;

    padding: 0.75rem;

    width: 98%;
    height: 98%;
    margin: auto;

    margin-top: 0.2rem;

    position: relative;
}

.option:first-child {
    margin-top: 0;
}


.option label {
    color: var(--text-color2);
}

.option:has(input:checked),
.option:hover {
    border-radius: 8px;
    color: var(--branco-padrao);
    background-color: var(--azul-dixi);
}

.option:has(input:focus) {
    outline: 1px solid var(--azul-dixi);
}

.option input[type="radio"] {
    all: unset;

    position: absolute;
    inset: 0;

    cursor: pointer;
}

.select:has(.option input:checked) #custom-select-container label {
    color: var(--azul-dixi);
}

.select:has(.option input:checked) #custom-select-container {
    color: var(--azul-dixi);
}

.nao-visivel {
    display: none;
}

.inclicavel {
    pointer-events: none;
}

.inclicavel-campo {
    /* Adiciona um efeito de bloqueado para clicar */
    background-color: var(--fundo-input2);
    color: var(--cinza-em-aberto);  
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomSelectAdvanced/CustomSelectAdvanced.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;;IAE9B,sBAAsB;IACtB,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;;IAEV,kBAAkB;IAClB,QAAQ;;IAER,eAAe;IACf,UAAU;AACd;;AAEA;IACI,qCAAqC;;IAErC,0BAA0B;;IAE1B,2CAA2C;IAC3C,sCAAsC;;IAEtC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;;IAEV,gBAAgB;;IAEhB,UAAU;IACV,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,UAAU;;IAEV,kBAAkB;IAClB,QAAQ;;IAER,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;IAChD,qCAAqC;IACrC,6BAA6B;IAC7B,mBAAmB;AACvB","sourcesContent":[".estilo-titulo-select {\n    font-size: .85rem;\n    font-weight: bold;\n    color: var(--cinza-em-aberto);\n}\n\n#select-button {\n    margin-top: 0.15rem;\n    display: flex;\n    padding: 0.75rem;   \n    align-items: center;\n    justify-content: space-between;\n\n    border-radius: .375rem;\n    border: 1ox solid var(--fundo-input2);\n    background-color: var(--fundo-input2);\n}\n\n.texto-azul {\n    color: var(--azul-dixi);\n}\n\n#selected-value {\n    color: var(--branco-padrao);\n    font-size: 1rem;\n}\n\n#chevrons {\n    color: var(--branco-padrao);\n}\n\n.pra-cima-select {\n    display: none;\n}\n\n#options-view-button:focus + #select-button,\n#options-view-button:checked + #select-button {\n    outline: 1px solid var(--azul-dixi);\n}\n\n#custom-select-container {\n    position: relative;\n}\n\n#options-view-button {\n    all: unset;\n\n    position: absolute;\n    inset: 0;\n\n    cursor: pointer;\n    z-index: 3;\n}\n\n#options {\n    background-color: var(--fundo-input2);\n\n    border-radius: 0 0 8px 8px;\n\n    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);\n    outline: 1px solid var(--fundo-input2);\n\n    padding: .4rem 0.1rem;\n}\n\n.option {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n\n    padding: 0.75rem;\n\n    width: 98%;\n    height: 98%;\n    margin: auto;\n\n    margin-top: 0.2rem;\n\n    position: relative;\n}\n\n.option:first-child {\n    margin-top: 0;\n}\n\n\n.option label {\n    color: var(--text-color2);\n}\n\n.option:has(input:checked),\n.option:hover {\n    border-radius: 8px;\n    color: var(--branco-padrao);\n    background-color: var(--azul-dixi);\n}\n\n.option:has(input:focus) {\n    outline: 1px solid var(--azul-dixi);\n}\n\n.option input[type=\"radio\"] {\n    all: unset;\n\n    position: absolute;\n    inset: 0;\n\n    cursor: pointer;\n}\n\n.select:has(.option input:checked) #custom-select-container label {\n    color: var(--azul-dixi);\n}\n\n.select:has(.option input:checked) #custom-select-container {\n    color: var(--azul-dixi);\n}\n\n.nao-visivel {\n    display: none;\n}\n\n.inclicavel {\n    pointer-events: none;\n}\n\n.inclicavel-campo {\n    /* Adiciona um efeito de bloqueado para clicar */\n    background-color: var(--fundo-input2);\n    color: var(--cinza-em-aberto);  \n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
